export const ORG_CONTEXT_ACTION_TYPES = {
  SET_ACTIVE_ORGS: 'set-active-orgs',
  SET_LAST_FARM_ID: 'set-last-farm-id',
  SET_LAST_SEASON_ID: 'set-last-season-id',
  BUMP_SEASON_LIST_KEY: 'bump-season-list-key',
  SET_HOVERED_ORG: 'set-hovered-org',
  SET_HOVERED_TASK: 'set-hovered-task',
  SET_HOVERED_TASK_GAP: 'set-hovered-task-gap',
}

export const initialState = {
  activeOrgs: [],
  lastSelectedFarmId: null,
  lastSelectedSeasonId: null,
  seasonListRefreshKey: 0,
  hoveredOrg: null,
  hoveredTask: null,
  hoveredTaskGap: null,  // 'now' | '1w' | '2w' | '1m' | 'all' | null
}

export function OrgContextReducer(state, action) {
  switch(action.type) {
    case ORG_CONTEXT_ACTION_TYPES.SET_ACTIVE_ORGS:
      return {
        ...state,
        activeOrgs: action.activeOrgs
      }
  
    case ORG_CONTEXT_ACTION_TYPES.SET_ALL_ORGS:
      return {
        ...state,
        allOrgs: action.allOrgs
      }
  
    case ORG_CONTEXT_ACTION_TYPES.SET_LAST_FARM_ID:
      return {
        ...state,
        lastSelectedFarmId: action.farmId
      }

    case ORG_CONTEXT_ACTION_TYPES.SET_LAST_SEASON_ID:
      return {
        ...state,
        lastSelectedSeasonId: action.seasonId
      }

    case ORG_CONTEXT_ACTION_TYPES.BUMP_SEASON_LIST_KEY:
      return {
        ...state,
        seasonListRefreshKey: state.seasonListRefreshKey + 1,
      }

    case ORG_CONTEXT_ACTION_TYPES.SET_HOVERED_ORG:
      return {
        ...state,
        hoveredOrg: action.hoveredOrg
      }

    case ORG_CONTEXT_ACTION_TYPES.SET_HOVERED_TASK:
      return {
        ...state,
        hoveredTask: action.hoveredTask
      }

    case ORG_CONTEXT_ACTION_TYPES.SET_HOVERED_TASK_GAP:
      return {
        ...state,
        hoveredTaskGap: action.hoveredTaskGap
      }

    default: {
      throw new Error('Unknown action sent to OrgContextReducer:', action.type)
    }
  }
}
